import(/* webpackMode: "eager" */ "/home/runner/work/web/web/src/app/submit-gossip/page.tsx");
